export const URL_GET_PROMO_LIST = "/v1/gocheckin/campaign/promotion/list?";
export const URL_GET_PROMO_LIST_EXPIRED = "/v1/gocheckin/campaign/promotion/list-expired?";
export const URL_GET_REMINDER_LIST = "/v1/gocheckin/campaign/reminder/list?";
export const URL_GET_BIRTHDAY_LIST = "/v1/gocheckin/campaign/birthday/list?";
export const URL_GET_CLIENT_LIST = "/v1/gocheckin/campaign/first-sign-up/get";
export const URL_ADD_PROMOTION = "/v1/gocheckin/campaign/promotion/create";
export const URL_UPDATE_REMINDER = "/v1/gocheckin/campaign/reminder/update?";
export const URL_UPDATE_BIRTHDAY = "/v1/gocheckin/campaign/birthday/update?";
export const URL_UPDATE_CLIENT = "/v1/gocheckin/campaign/first-sign-up/update";
export const URL_GET_GROUP_LIST = "/v1/gocheckin/campaign/promotion/get-groups";
export const URL_GET_PROMOTION_DETAIL = "/v1/gocheckin/campaign/promotion/get?";
export const URL_GET_REMINDER_DETAIL = "/v1/gocheckin/campaign/reminder/get?";
export const URL_GET_BIRTHDAY_DETAIL = "/v1/gocheckin/campaign/birthday/get?";
export const URL_CHECK_LIMIT_PROMOTION = "/v1/gocheckin/campaign/promotion/check-limit";
export const URL_CHECK_OPT_OUT_REQUIRED = "/v1/gocheckin/campaign/promotion/check-opt-out";
export const URL_SEND_TEST = "/v1/gocheckin/campaign/promotion/send-test";
export const URL_GET_CAMPAIGN_HISTORY_LIST = "/v1/gocheckin/campaign/site/get-history?";